import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { StoreAuthService } from '@app/core/auth/store-auth.service';
import { StoreUserService } from '@app/core/state/store-user.service';
import { DatabaseCacheService } from '../cache/database-cache.service';
import { getIsoDateTimeString, flattenJSON } from '../../utils';

@Injectable({
  providedIn: 'root'
})

export class CreateGost2Service {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService,
  ) { }

  createGost2(gost2RecordData) {

    let sectionId = this.common.getSelectedSection().sectionId;

    let loginUser = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(loginUser.idTokenClaims['sub']);

    let postBody = this.createPostBody(gost2RecordData);

    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    headers = headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    let url = `${apiConfig.uri}/licence/${sectionId}/recordWithData`;

    return this.httpClient.post(url, postBody, { headers: headers });
  }

  private createPostBody(gost2RecordData){

    // const currentDatetime = new Date();
    // let createdAt = getIsoDateTimeString(currentDatetime);
    let createdAt = getIsoDateTimeString(new Date(gost2RecordData.data.createdAt));

    let selectedUser = this.common.getSelectedUserWithUserData();

    // record の部分を作成する ======================================================================
    let record = {
      recordType : "GOST",
      version : 2,
      createdAt : createdAt,
      asOfDate : gost2RecordData.data.asOfDate,

      testDuration : 0,
      wavDuration : 0,
      nbId : null,
      nbModel : null,
      numOfSwallowings : null,
      totalTime : null,
      totalMilliseconds : null,
      swallowingsTimeAverage : null,
      swallowingsTimeVariance : null,
      beforeMealHrFingerAvg : null,
      beforeMealHrFingerMin : null,
      beforeMealHrFingerMax : null,
      beforeMealSpo2FingerAvg : null,
      beforeMealSpo2FingerMin : null,
      beforeMealSpo2FingerMax : null,
      numOfCoughs : null,
      numOfImmediateCoughs : null,
      hrAvg : null,
      hrMin : null,
      hrMax : null,

      userType : "INDIVIDUAL",
      userId : selectedUser.user.userId,
      sex : selectedUser.user.sex,
      age : selectedUser.user.age,
      code : selectedUser.user.code,
    }

    // recordData の部分を作成する ======================================================================
    let recordData :any = gost2RecordData; // まずまるごとコピーする
    // 一部の項目は入っていないかもしれないので、念のため割り当てしなおす
    recordData.data.createdAt = createdAt;

    recordData.data.userType =  "INDIVIDUAL";
    recordData.data.sex = selectedUser.user.sex;
    recordData.data.age = selectedUser.user.age;
    recordData.data.code = selectedUser.user.code;

    recordData.data.termsAgreed = true;

    // // もし元になるSCレコードが指定されているときは そちらから必要な項目をコピーしてくる
    // if (originalScRecord){
    //   // todo 元のSCレコードからデータを取ってきて必要なところにいれる
    //   // todo 2023/03/18の時点ではSCレコード自体の構造が決まっていないので、SCレコードが実装されたときに作り直す必要がある
    //   record = flattenJSON(originalScRecord);

    //   record.recordType = "GOST";
    //   record.version = 2;
    //   record.createdAt = createdAt;

    //   recordData.originalSCRecordId = originalScRecord.id;
    //   recordData.originalScRecordCreatedAt = originalScRecord.data.createdAt;
    // }

    //
    let postBody : any = {};

    postBody.record = record;
    postBody.recordData = recordData;

    return postBody;
  }

}
